import React, { useRef } from "react";

export interface CarouselCard {
  id: string;
  category: string;
  timeAgo: string;
  title: string;
  actionLabel?: string;
  muted?: boolean;
  onClick?: () => void;
  onAction?: () => void;
}

interface FeatureCarouselProps {
  cards: CarouselCard[];
}

export const FeatureCarousel: React.FC<FeatureCarouselProps> = ({ cards }) => {
  const trackRef = useRef<HTMLDivElement>(null);

  const scrollNext = () => {
    trackRef.current?.scrollBy({ left: 300, behavior: "smooth" });
  };

  if (!cards.length) return null;

  return (
    <div className="vault-carousel">
      <div className="vault-carousel-track" ref={trackRef}>
        {cards.map((card) => (
          <div
            key={card.id}
            className="vault-carousel-card"
            onClick={card.onClick}
          >
            <div className="vault-card-meta">
              <div className={`vault-dot ${card.muted ? "muted" : ""}`} />
              {card.category} &bull; {card.timeAgo}
            </div>
            <div className="vault-card-title">{card.title}</div>
            {card.actionLabel && (
              <button
                className="vault-card-action"
                onClick={(e) => {
                  e.stopPropagation();
                  card.onAction?.();
                }}
              >
                {card.actionLabel}
              </button>
            )}
          </div>
        ))}
      </div>
      {cards.length > 3 && (
        <button className="vault-carousel-next" onClick={scrollNext}>
          &#8250;
        </button>
      )}
    </div>
  );
};
